export default __webpack_public_path__ + "static/media/location-active-icon.d972ff48.svg";